module.exports = __webpack_public_path__ + "media/images/ae-logo-841676f4dbbcdc126e2479d44283b947.svg";